import React from 'react';
import { Star, StarHalf } from 'lucide-react';
import './TestimonialCarousel.css';

export const TestimonialCarousel = () => {
  const testimonials = [
    {
      name: 'S. Weber',
      role: 'Verkäuferin, St. Gallen',
      rating: 4.5,
      comment: 'Der Verkauf unserer Liegenschaft wurde durch die LIVAG perfekt orchestriert. Professionelle Vermarktung und exzellente Betreuung während des gesamten Prozesses.'
    },
    {
      name: 'M. Keller',
      role: 'Privater Bauherr, Rorschach',
      rating: 5,
      comment: 'Von der ersten Projektidee bis zur Umsetzung wurden wir kompetent begleitet. Besonders überzeugt hat uns die klare Struktur und Transparenz.'
    },
    {
      name: 'L. Baumann',
      role: 'Investorin, Zürich',
      rating: 5,
      comment: 'Die LIVAG versteht Immobilienentwicklung ganzheitlich. Wirtschaftlichkeit, Architektur und Marktverständnis greifen perfekt ineinander.'
    },
    {
      name: 'F. Huber',
      role: 'Verkäufer, Herisau',
      rating: 4.5,
      comment: 'Sehr professionelle Abwicklung beim Verkauf unserer Immobilie. Klare Kommunikation, realistische Einschätzung und zielgerichtete Vermarktung.'
    },
    {
      name: 'C. Steiner',
      role: 'Eigentümerin, Arbon',
      rating: 5,
      comment: 'Die Bauherrenberatung der LIVAG war für uns extrem wertvoll. Viele Fehler konnten so frühzeitig vermieden werden.'
    },
    {
      name: 'D. Pfister',
      role: 'Projektentwickler, Winterthur',
      rating: 5,
      comment: 'Die Zusammenarbeit war effizient, lösungsorientiert und auf Augenhöhe. Die LIVAG denkt unternehmerisch und langfristig.'
    },
    {
      name: 'N. Hartmann',
      role: 'Verkäuferin, Wil',
      rating: 4.5,
      comment: 'Ich habe mich während des gesamten Verkaufsprozesses bestens aufgehoben gefühlt. Fachlich stark und menschlich sehr angenehm.'
    },
    {
      name: 'R. Brunner',
      role: 'Bauherr, Appenzell',
      rating: 5,
      comment: 'Die strategische Beratung und Projektstrukturierung war entscheidend für den Erfolg unseres Bauvorhabens.'
    },
    {
      name: 'S. König',
      role: 'Eigentümerin, Gossau',
      rating: 4.5,
      comment: 'Professionelle Immobilienentwicklung mit viel Erfahrung. Besonders geschätzt habe ich die ehrliche Einschätzung der Machbarkeit.'
    },
    {
      name: 'T. Meier',
      role: 'Investor, Pfäffikon',
      rating: 5,
      comment: 'Die LIVAG denkt Immobilien nicht nur architektonisch, sondern auch wirtschaftlich. Genau das habe ich gesucht.'
    },
    {
      name: 'A. Jäger',
      role: 'Verkäufer, St. Margrethen',
      rating: 4.5,
      comment: 'Klare Prozesse, fundierte Marktkenntnis und eine saubere Verkaufsabwicklung. Absolut empfehlenswert.'
    },
    {
      name: 'M. Lüthi',
      role: 'Bauherrin, Glattbrugg',
      rating: 5,
      comment: 'Die Beratung war strukturiert, realistisch und lösungsorientiert. Besonders die Kosten- und Termintransparenz war hervorragend.'
    },
    {
      name: 'P. Schneider',
      role: 'Immobilienbesitzer, Kloten',
      rating: 4.5,
      comment: 'Von der Projektprüfung bis zur Umsetzung ein sehr verlässlicher Partner. Man merkt die Erfahrung in der Immobilienentwicklung.'
    },
    {
      name: 'E. Vogel',
      role: 'Verkäuferin, St. Gallen',
      rating: 5,
      comment: 'Die Vermarktung unserer Immobilie war hochwertig und professionell. Die LIVAG hat den optimalen Käufer gefunden.'
    },
    {
      name: 'J. Lüchinger',
      role: 'Unternehmer, Rorschach',
      rating: 5,
      comment: 'Die Kombination aus Bauherrenberatung, Projektentwicklung und Marktkenntnis macht die LIVAG für uns einzigartig.'
    }
  ];

  // Duplicate testimonials for seamless infinite scroll
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    
    return (
      <div className="stars-container">
        {[...Array(5)].map((_, index) => {
          if (index < fullStars) {
            return (
              <Star
                key={index}
                size={20}
                className="star-filled"
                fill="#F59E0B"
                stroke="#F59E0B"
              />
            );
          } else if (index === fullStars && hasHalfStar) {
            return (
              <div key={index} className="half-star-container">
                <Star
                  size={20}
                  className="star-empty"
                  fill="none"
                  stroke="#D1D5DB"
                />
                <div className="half-star-overlay">
                  <Star
                    size={20}
                    fill="#F59E0B"
                    stroke="#F59E0B"
                  />
                </div>
              </div>
            );
          } else {
            return (
              <Star
                key={index}
                size={20}
                className="star-empty"
                fill="none"
                stroke="#D1D5DB"
              />
            );
          }
        })}
      </div>
    );
  };

  return (
    <section className="testimonial-carousel-section">
      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-normal text-[#264F77] text-center mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Das sagen unsere Kunden.
          </h2>
          <p className="text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto">
            Erfahrungen und Bewertungen von Kunden, die mit der LIVAG zusammengearbeitet haben
          </p>
        </div>
        <div className="testimonial-carousel-fullwidth">
          <div className="testimonial-carousel-track">
            {duplicatedTestimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-header">
                  <div className="testimonial-avatar">
                    <span className="avatar-initials">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div className="testimonial-info">
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    <p className="testimonial-role">{testimonial.role}</p>
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
                <p className="testimonial-comment">"{testimonial.comment}"</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
